import type { MapId } from '@cc/shared';

const BASE = '/chance';

async function request<T>(path: string, options?: RequestInit): Promise<T> {
  const response = await fetch(path, { ...options, headers: { 'content-type': 'application/json', ...options?.headers } });
  const body = await response.json().catch(() => ({})) as T & { error?: string };
  if (!response.ok) throw new Error(body.error ?? 'Request failed.');
  return body;
}

export interface CreateRoomResponse { code: string; token: string; joinUrl: string }
export interface RoomSummary { status: 'waiting' | 'playing' | 'finished' | 'not_found'; mapId?: MapId; creatorName?: string; joinable: boolean }

export const api = {
  createRoom: (input: { name: string; mapId: MapId; timerSeconds: 0 | 60 | 120 }) => request<CreateRoomResponse>(`${BASE}/api/rooms`, { method: 'POST', body: JSON.stringify(input) }),
  room: (code: string) => request<RoomSummary>(`${BASE}/api/rooms/${encodeURIComponent(code)}`),
};
